import { useLanguage } from "../context/LanguageContext";
import { scrollToId } from "../lib/scroll";
import { IkonsMark } from "./IkonsMark";
import { SITE_UPDATED, PLAYER } from "../data/siteData";

export const Footer = () => {
  const { lang, t } = useLanguage();

  return (
    <footer className="border-t border-ink-700/60 bg-ink-900/60 py-10" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-4 sm:px-6 md:flex-row md:items-center">
        <div>
          <IkonsMark className="h-9" />
          <p className="mt-3 max-w-md text-xs leading-relaxed text-zinc-500" data-testid="footer-managed-note">
            {t.footer.managed}
          </p>
        </div>
        <div className="text-left md:text-right">
          <button
            data-testid="footer-player-link"
            onClick={() => scrollToId("inicio")}
            className="font-display text-lg font-bold uppercase tracking-wide text-white transition-colors duration-200 hover:text-kit"
          >
            {PLAYER.name}
          </button>
          <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-500" data-testid="footer-updated-note">
            {t.footer.updated}: {SITE_UPDATED[lang]} · {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
